import { render, staticRenderFns } from "./MiniWizardSticky.vue?vue&type=template&id=6a0cdd4a&"
import script from "./MiniWizardSticky.vue?vue&type=script&lang=js&"
export * from "./MiniWizardSticky.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports